import { useEffect, useState } from "react";
import { Button, Input, message, Modal, Spin } from "antd";
import moment from "moment";
import { ConditionalRenderer } from "components";
import { ExtendSubscriptionImage, SelectedTick } from "icons";
import { useCurrentUserContext } from "providers";
import { UseLazyApiCall } from "hooks";
import { PLAN_KEYS } from "pages/analyticsV2/components/addUserModalV2/constants";
import { TickIcon } from "pages/settings/icons";
import { expiresInDays, getDateAfterMonths } from "utils/helpers";
import { END, planDuration, planTypes } from "./constants";
import styles from "./styles.module.scss";

export const SubscriptionDetail = ({
  userID,
  currentSubscriptionLoading,
  currentSubscriptionRefetch,
  currentPlanObj,
  closeExtendPopUp,
}) => {
  const { user } = useCurrentUserContext();
  const [activeOption, setActiveOption] = useState(planTypes[0]);
  const [duration, setDuration] = useState(planDuration[0]);
  const [expiryAfterExtension, setExpiryAfterExtension] = useState();

  const [modifySubscription, { isLoading: modifySubscriptionLoading }] =
    UseLazyApiCall({
      url: "/internal/editSubscription",
      method: "POST",
    });

  function setToInitialState() {
    if (currentPlanObj) {
      setActiveOption(
        planTypes.find(
          (item) => item.months === currentPlanObj?.subscriptionMonths
        )
      );

      setDuration(
        planDuration.find(
          (item) => item.months === currentPlanObj?.subscriptionMonths
        )
      );
    }
  }

  function handleClickOption(option) {
    setActiveOption(option);
    if (option.key === PLAN_KEYS.PREMIUM) {
      setDuration(null);
    } else {
      setDuration(planDuration[0]);
      handleExpiry(planDuration[0].months);
    }
    // setSelectedData(availableData[option.key]);
  }
  function handleClickDuration(option) {
    setDuration(option);
    handleExpiry(option.months);
  }

  async function handleExtendSubscription(type) {
    const params = {
      userId: userID,
      email: user?.email,
      newExpiryMonths:
        type === END ? "0" : JSON.stringify(duration?.months) || null,
      mode: activeOption.key?.toLowerCase(),
    };

    try {
      const response = await modifySubscription({
        params,
      });

      if (response) {
        message.success("Subscription Updated succesffuly");
        currentSubscriptionRefetch();
        closeExtendPopUp();
      }
    } catch (error) {
      console.log({ error });
    }
  }

  function handleClickCancel() {
    setToInitialState();
  }

  function handleExpiry(months) {
    const date = getDateAfterMonths(months);
    const days = expiresInDays(date);
    const formattedDate = moment(date).format("ll");
    setExpiryAfterExtension(`${days} days on ${formattedDate}`);
  }
  useEffect(() => {
    handleExpiry(planDuration[0].months);
  }, []);

  return (
    <Modal
      centered
      onCancel={closeExtendPopUp}
      open
      footer={null}
      title={<ModalTitle />}
      width={"fit-content"}
      styles={{
        body: {
          height: "fit-content",
          width: "700px",
        },
      }}
    >
      <Spin spinning={modifySubscriptionLoading}>
        <div className={styles.extendPlan}>
          <div className={styles.planSelection}>
            <div className={styles.planOptions}>
              {planTypes?.map((item) => {
                const isActive = activeOption?.key === item.key;

                return (
                  <div
                    className={`${styles.singlePlanOption} ${
                      isActive && styles.active
                    }`}
                    onClick={() => handleClickOption(item)}
                  >
                    <div key={item.key} className={styles.titleAndRadio}>
                      <div className={styles.title}>{item.title}</div>
                      <ConditionalRenderer condition={isActive}>
                        <SelectedTick />
                      </ConditionalRenderer>
                      <ConditionalRenderer condition={!isActive}>
                        <div className={`${styles.radioBtn}`}></div>
                      </ConditionalRenderer>
                    </div>
                    <div className={styles.platforms}>
                      {item?.platforms?.map((item) => (
                        <div
                          key={item.title}
                          style={{ backgroundColor: `${item.bgColor}` }}
                          className={styles.singlePlatform}
                        >
                          <item.icon height={15} width={15} /> {item.title}
                        </div>
                      ))}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>

          <ConditionalRenderer
            condition={
              activeOption?.key === PLAN_KEYS.BASIC ||
              activeOption?.key === PLAN_KEYS.STANDARD
            }
          >
            <div className={styles.selectContainer}>
              <h3>Select Duration</h3>

              <div className={styles.planOptions}>
                {planDuration?.map((item) => {
                  const isActive = duration?.key === item.key;

                  return (
                    <div
                      key={item?.key}
                      className={`${styles.singlePlanOption} ${
                        isActive && styles.active
                      }`}
                      onClick={() => handleClickDuration(item)}
                    >
                      <div className={styles.title}>{item.title}</div>
                      <ConditionalRenderer condition={isActive}>
                        <SelectedTick />
                      </ConditionalRenderer>
                      <ConditionalRenderer condition={!isActive}>
                        <div className={`${styles.radioBtn}`}></div>
                      </ConditionalRenderer>
                    </div>
                  );
                })}
              </div>
            </div>
            <div className={styles.expiry}>
              <ConditionalRenderer
                condition={
                  activeOption.key === PLAN_KEYS.BASIC ||
                  activeOption.key === PLAN_KEYS.STANDARD
                }
              >
                <div className={styles.label}>
                  Subscription of this user will expire in:
                </div>
                <div className={styles.date}>{expiryAfterExtension}</div>
              </ConditionalRenderer>
            </div>
          </ConditionalRenderer>
          <ConditionalRenderer
            condition={activeOption?.key === PLAN_KEYS.PREMIUM}
          >
            <div className={styles.licenseLabel}>Enter License Key</div>

            <div className={styles.license}>
              <Input
                style={{ height: "36px" }}
                type="text"
                placeholder="e.g 97UG8473VH"
                // value={userFormData.license}
                // onChange={handleChangeForm}
                name="license"
                maxLength={10}
                suffix={<TickIcon height={15} width={15} />}
              />
              <button
                className={styles.disabled}
                style={{ opacity: "0.5", pointerEvents: "none" }}
              >
                Redeem
              </button>
            </div>
          </ConditionalRenderer>
        </div>
        <div className={styles.buttons}>
          <div className={styles.cancelSave}>
            <Button
              style={{ backgroundColor: "#FF3A3A", color: "white" }}
              size="large"
              onClick={() => handleExtendSubscription(END)}
              disabled={!activeOption}
            >
              End Subscription
            </Button>
            <Button
              style={{ backgroundColor: "#012D4D", color: "white" }}
              size="large"
              // disabled
              type="primary"
              disabled={!activeOption || currentSubscriptionLoading}
            >
              Pause Subscription
            </Button>
          </div>
          <div className={styles.cancelSave}>
            <Button
              style={{ backgroundColor: "#6F7174", color: "white" }}
              size="large"
              onClick={handleClickCancel}
              disabled={!activeOption}
            >
              Cancel
            </Button>
            <Button
              style={{ backgroundColor: "#006AB3", color: "white" }}
              size="large"
              type="primary"
              onClick={handleExtendSubscription}
              disabled={
                !activeOption ||
                currentSubscriptionLoading ||
                activeOption.key === PLAN_KEYS.PREMIUM
              }
            >
              Save
            </Button>
          </div>
        </div>
      </Spin>
    </Modal>
  );
};

function ModalTitle() {
  return (
    <div className={styles.header}>
      <div className={styles.extendIcon}>
        <ExtendSubscriptionImage />
      </div>
      <div className={styles.title}>Renew Subscription</div>
    </div>
  );
}
